import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.svg`
  display: block;
`;

export const PlayIcon = () => (
  <IconWrapper width="18" height="18" viewBox="0 0 18 18">
    <circle cx="9" cy="9" r="9" fill="none" />
    <polygon points="6,4 14,9 6,14" fill="currentColor" />
  </IconWrapper>
);

export const PauseIcon = () => (
  <IconWrapper width="18" height="18" viewBox="0 0 18 18">
    <circle cx="9" cy="9" r="9" fill="none" />
    <rect x="5" y="4" width="3" height="10" rx="1" fill="currentColor" />
    <rect x="10" y="4" width="3" height="10" rx="1" fill="currentColor" />
  </IconWrapper>
);

export const PreviousIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4L6 8L10 12" stroke="inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </IconWrapper>
);

export const NextIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4L10 8L6 12" stroke="inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </IconWrapper>
);

export const NavigationPreviousIcon = () => (
  <IconWrapper width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="2" fill="none" />
    <polyline points="17,8 11,14 17,20" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </IconWrapper>
);

export const NavigationNextIcon = () => (
  <IconWrapper width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="2" fill="none" />
    <polyline points="11,8 17,14 11,20" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </IconWrapper>
);

export const UploadIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 17V7M10 7L6 11M10 7L14 11" stroke="#72d2ff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </IconWrapper>
);

export const VideoIcon = () => (
  <IconWrapper width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="16" width="48" height="32" rx="6" fill="#0a1e38" stroke="rgba(114, 210, 255, 0.25)" strokeWidth="2"/>
    <polygon points="28,26 44,32 28,38" fill="#72d2ff" />
  </IconWrapper>
);

export const EmptyStatePlayIcon = () => (
  <IconWrapper width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5L19 12L8 19V5Z" fill="currentColor" />
  </IconWrapper>
);

export const ZoomInIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </IconWrapper>
);

export const ZoomOutIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </IconWrapper>
);

export const KeyboardIcon = () => (
  <IconWrapper width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <rect x="4" y="8" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="7" y="8" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="10" y="8" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="13" y="8" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="16" y="8" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="4" y="11" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="7" y="11" width="6" height="2" rx="0.5" fill="currentColor"/>
    <rect x="16" y="11" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="4" y="14" width="2" height="2" rx="0.5" fill="currentColor"/>
    <rect x="7" y="14" width="10" height="2" rx="0.5" fill="currentColor"/>
    <rect x="18" y="14" width="2" height="2" rx="0.5" fill="currentColor"/>
  </IconWrapper>
);

export const AzureIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="white" strokeWidth="2" fill="none"/>
    <path d="M7 12L12 7L17 12L12 17L7 12Z" fill="white"/>
  </IconWrapper>
);

export const CloudIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 10H16.74C16.24 6.67 13.39 4 10 4C6.61 4 3.76 6.67 3.26 10H2C.9 10 0 10.9 0 12S.9 14 2 14H18C19.1 14 20 13.1 20 12S19.1 10 18 10Z" fill="#0078d4"/>
    <path d="M22 16C22 18.21 20.21 20 18 20H6C3.79 20 2 18.21 2 16" stroke="#0078d4" strokeWidth="2" fill="none"/>
  </IconWrapper>
);

export const FolderIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V9C21 7.9 20.1 7 19 7H12L10 5H5C3.9 5 3 5.9 3 7Z" stroke="currentColor" strokeWidth="2" fill="none"/>
  </IconWrapper>
);

export const FileIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" fill="none"/>
  </IconWrapper>
);

export const ContainerIcon = () => (
  <IconWrapper width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="6" width="18" height="12" rx="2" stroke="#0078d4" strokeWidth="2" fill="none"/>
    <path d="M7 6V4C7 3.45 7.45 3 8 3H16C16.55 3 17 3.45 17 4V6" stroke="#0078d4" strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="2" fill="#0078d4"/>
  </IconWrapper>
);